//
// Splide Config
// --------------------------------------------------
// Checks page for panels utilising splide and initialises their splide sliders with configurations set here

import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';
import { PageUtils } from "./helpers/page-utils";

function closeLightBox(lightbox) {
    lightbox.dataset.visible = 'false';
    PageUtils.bodyLockToggleOff();
    setTimeout(() => {
        lightbox.dataset.hidden = 'true';
    }, 300);

    const siteHeader = document.querySelector('#siteHeader');
    const desktopToggleWrapper = document.querySelector('.desktop-toggle-wrapper');
    if (siteHeader) {
        siteHeader.classList.remove('!hidden');
    }
    if (desktopToggleWrapper) {
        desktopToggleWrapper.classList.remove('!hidden');
    }
}

function openLightBox(lightbox) {
    lightbox.dataset.hidden = 'false';
    PageUtils.bodyLockToggleOn();
    setTimeout(() => {
        lightbox.dataset.visible = 'true';
    }, 50);

    const siteHeader = document.querySelector('#siteHeader');
    const desktopToggleWrapper = document.querySelector('.desktop-toggle-wrapper');
    if (siteHeader) {
        siteHeader.classList.add('!hidden');
    }
    if (desktopToggleWrapper) {
        desktopToggleWrapper.classList.add('!hidden');
    }
}

function documentKeydownHandler(event, lightbox, splide) {
    if (lightbox.dataset.hidden === 'false') {
        if (event.key === 'Escape') {
            closeLightBox(lightbox);
        }
        else if (event.key === 'ArrowRight') {
            splide.go('+1');
        }
        else if (event.key === 'ArrowLeft') {
            splide.go('-1');
        }
    }
}

window.addEventListener('load', () => {
    const availableCarousels = document.querySelectorAll('.splide');
    const gallerySplidePanel = document.querySelectorAll('.gallery-panel');

    if (availableCarousels.length) {
        // START GALLERY PANEL SLIDER
        for ( let panel of gallerySplidePanel ) {
            const galleryThumbnails = panel.querySelectorAll('.gallery-panel-image');
            const lightbox = panel.querySelector('[data-lightbox="gallery-panel"]');
            const requiredSplidesPresent = !!(panel.querySelector('.gallery-lightbox-splide') && panel.querySelector('.gallery-splide'));

            if (requiredSplidesPresent) {
                const galleryLightboxSplide = new Splide(panel.querySelector('.gallery-lightbox-splide'), {
                    type: 'fade',
                    speed: 750,
                    arrows: true,
                    pagination: false,
                    arrowPath: 'M8.32248 20.9138L29.4625 20.9138L19.3525 31.0238C18.9925 31.3838 18.9925 31.9538 19.3525 32.3138C19.7125 32.6738 20.2825 32.6638 20.6425 32.3138L32.3125 20.6438C32.3925 20.5638 32.4625 20.4638 32.5025 20.3538C32.5925 20.1338 32.5925 19.8838 32.5025 19.6538C32.4625 19.5438 32.3925 19.4438 32.3125 19.3638L20.6425 7.69383C20.4625 7.51383 20.2325 7.42383 20.0025 7.42383C19.7725 7.42383 19.5325 7.51383 19.3625 7.69383C19.0025 8.04383 19.0025 8.62383 19.3625 8.98383L29.4725 19.1038L8.33249 19.1038C7.83249 19.1038 7.42249 19.5138 7.42249 20.0138C7.42249 20.5138 7.83249 20.9238 8.33249 20.9238L8.32248 20.9138Z',
                    classes: {
                        arrows: 'splide__arrows absolute w-full h-full flex items-center justify-between',
                        arrow: 'splide__arrow relative flex items-center justify-center z-3 rounded-l-lg w-14 h-16 p-2 bg-black/20 2.5xl:bg-transparent 2.5xl:p-0 2.5xl:w-10 2.5xl:h-12 fill-current text-white disabled:text-white/20 transition-all duration-300 hover:scale-110 disabled:!scale-100',
                        prev: 'splide__arrow--prev left-0 2.5xl:-left-16 rotate-180',
                        next: 'splide__arrow--next right-0 2.5xl:-right-16',
                    },
                });

                const gallerySplide = new Splide(panel.querySelector('.gallery-splide'), {
                    type: 'carousel',
                    speed: 750,
                    direction: 'ltr',
                    pauseOnHover: true,
                    arrows: false,
                    perPage: 3,
                    perMove: 1,
                    pagination: false,
                    autoplay: true,
                    interval: 10000,
                    gap: '2rem',
                    padding: '2rem',
                    destroy: true,
                    arrowPath: 'M8.32248 20.9138L29.4625 20.9138L19.3525 31.0238C18.9925 31.3838 18.9925 31.9538 19.3525 32.3138C19.7125 32.6738 20.2825 32.6638 20.6425 32.3138L32.3125 20.6438C32.3925 20.5638 32.4625 20.4638 32.5025 20.3538C32.5925 20.1338 32.5925 19.8838 32.5025 19.6538C32.4625 19.5438 32.3925 19.4438 32.3125 19.3638L20.6425 7.69383C20.4625 7.51383 20.2325 7.42383 20.0025 7.42383C19.7725 7.42383 19.5325 7.51383 19.3625 7.69383C19.0025 8.04383 19.0025 8.62383 19.3625 8.98383L29.4725 19.1038L8.33249 19.1038C7.83249 19.1038 7.42249 19.5138 7.42249 20.0138C7.42249 20.5138 7.83249 20.9238 8.33249 20.9238L8.32248 20.9138Z',
                    classes: {
                        pagination: 'hidden',
                        arrows: 'hidden',
                    },
                    breakpoints: {
                        1023: {
                            perPage: 2.2,
                            padding: '1.5rem',
                            gap: '1.5rem',
                            destroy: false,
                        },
                        767: {
                            perPage: 2.2,
                            padding: '1.5rem',
                            gap: '1.5rem',
                            destroy: false,
                        },
                        639: {
                            perPage: 1.2,
                            padding: '1.5rem',
                            gap: '1.5rem',
                            destroy: false,
                        },
                    },
                });

                if (lightbox) {
                    const lightboxBackdrop = lightbox.querySelector('[data-lightbox-backdrop]');
                    const lightboxClose = lightbox.querySelector('[data-lightbox-close]');
                    const lightboxProgressBar = lightbox.querySelector('[data-carousel-progress]');

                    // Closes lightbox on backdrop/close button press
                    if (lightboxBackdrop) {
                        lightboxBackdrop.addEventListener('click', () => closeLightBox(lightbox));
                    }
                    if (lightboxClose) {
                        lightboxClose.addEventListener('click', () => closeLightBox(lightbox));
                    }

                    // Updates carousel progress bar width
                    if (lightboxProgressBar) {
                        galleryLightboxSplide.on('mounted move', function () {
                            let end = galleryLightboxSplide.Components.Controller.getEnd() + 1;
                            lightboxProgressBar.style.width = String(100 * (galleryLightboxSplide.index + 1) / end) + '%';
                        });
                    }

                    // Closes lightbox on key 'esc' press or navigates slider on keys 'arrowLeft' and 'arrowRight'
                    document.addEventListener('keydown', (e) => documentKeydownHandler(e, lightbox, galleryLightboxSplide));
                }

                // Opens lightbox and navigates carousel to the thumbnail that was pressed
                for ( let thumbnail of galleryThumbnails ) {
                    thumbnail.addEventListener('click', () => {
                        if (thumbnail.dataset.slide.length) {
                            galleryLightboxSplide.go(parseInt(thumbnail.dataset.slide));
                        }
                        openLightBox(lightbox);
                    });
                }

                galleryLightboxSplide.mount();
                gallerySplide.mount()
                gallerySplide.sync(galleryLightboxSplide);
            }
        }
        // END GALLERY PANEL SLIDER
    }
});
